<header class="main-header">
  <div class="header-inner" id="app">
    <div class="logo">
      <img src="../assets/new-logo-2.png" [alt]="'login_page.company_logo_alt' | translate"/>
    </div>


    <div style="display: flex;gap: 1rem;">

      <div class="lang-toggle" role="group" aria-label="Sprache / Language">
        <button type="button" class="lang-toggle__btn" [class.lang-toggle__btn--active]="currentLang === 'de'"
                [attr.aria-pressed]="currentLang === 'de'" (click)="changeLanguage('de')">DE</button>
        <button type="button" class="lang-toggle__btn" [class.lang-toggle__btn--active]="currentLang === 'en'"
                [attr.aria-pressed]="currentLang === 'en'" (click)="changeLanguage('en')">EN</button>
      </div>
      <app-button
        [isFullWidth]="false"
        [label]="'auth.login' | translate"
        [size]="ButtonSize.LARGE"
        [state]="ButtonState.REGULAR"
        [type]="ButtonType.SECONDARY"
        (click)="openLoginModal()"
      ></app-button>

      <app-button
        [isFullWidth]="false"
        [label]="'auth.register' | translate"
        [size]="ButtonSize.LARGE"
        [state]="ButtonState.REGULAR"
        [type]="ButtonType.PRIMARY"
        (click)="openRegistrationModal()"
      ></app-button>

    </div>

  </div>
</header>

<!-- Content -->
<div class="container">

  <section class="hero-section">
    <div class="half-circle-gradient"></div>
    <div class="header">
      <app-motto-card></app-motto-card>
    </div>

    <!-- Employer / Candidate role selection -->
    <div class="role-selection-grid">

      <!-- Employer box (darker, bolder) -->
      <div class="role-card role-card--employer">
        <div class="role-card__icon">
          <i class="fa fa-building"></i>
        </div>
        <h2 class="role-card__title">{{ 'role_selection.employer_title' | translate }}</h2>
        <p class="role-card__subtitle">{{ 'role_selection.employer_subtitle' | translate }}</p>
        <app-button
          style="z-index:9999;"
          [isFullWidth]="false"
          [label]="'role_selection.employer_cta' | translate"
          [size]="ButtonSize.LARGE"
          [state]="ButtonState.REGULAR"
          [type]="ButtonType.PRIMARY"
          (click)="openEmployerModal()"
        ></app-button>
      </div>

      <!-- Candidate box -->
      <div class="role-card role-card--candidate">
        <div class="role-card__icon">
          <i class="fa fa-user"></i>
        </div>
        <h2 class="role-card__title">{{ 'role_selection.candidate_title' | translate }}</h2>
        <p class="role-card__subtitle">{{ 'role_selection.candidate_subtitle' | translate }}</p>
        <app-button
          [isFullWidth]="false"
          [label]="'role_selection.candidate_cta' | translate"
          [size]="ButtonSize.LARGE"
          [state]="ButtonState.REGULAR"
          [type]="ButtonType.PRIMARY"
          (click)="openRegistrationModal()"
        ></app-button>
      </div>

    </div>

    <div class="app-badges">
      <a class="app-badge" href="https://apps.apple.com/de/app/bipperz/id6760047548" target="_blank" rel="noopener noreferrer">
        <svg class="app-badge__icon" viewBox="0 0 384 512" fill="currentColor" aria-hidden="true"><path d="M318.7 268c-.2-37 16.6-65 50.6-85.7-19-27.2-47.7-42.2-85.7-45.2-36-2.8-75.4 21-89.8 21-15.2 0-50-19.9-77.4-19.4C61.1 139.6 0 184.2 0 275.3c0 26.9 4.9 54.7 14.8 83.3 13.2 37.6 60.8 129.9 110.5 128.4 25.9-.6 44.2-18.4 78-18.4 32.8 0 49.7 18.4 77.4 18.4 50.1-.7 93.2-84.6 105.8-122.3-67.2-31.7-63.8-92.8-63.8-94.7zm-56.5-218.4c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26 2 49.7-11.4 69.5-34.3z"/></svg>
        <span class="app-badge__text"><small>{{ 'landing.app.download_on' | translate }}</small>App Store</span>
      </a>
      <a class="app-badge" href="https://play.google.com/store/apps/details?id=com.app.bipperz" target="_blank" rel="noopener noreferrer">
        <svg class="app-badge__icon" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true"><path d="M325.3 234.3 104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l220.7-221.3 60.1 60.1L104.6 499z"/></svg>
        <span class="app-badge__text"><small>{{ 'landing.app.get_it_on' | translate }}</small>Google Play</span>
      </a>
    </div>
  </section>

  <!-- <app-landing-stats></app-landing-stats> -->
  <app-landing-partners></app-landing-partners>

  <section id="section-about" class="about-section">
    <div class="about-content">
      <div class="glass-card">
        <div class="about-us">{{ 'about_us.label' | translate }}</div>

        <h1 class="about-title">
          {{ 'login_page.motto_third_line' | translate }}
        </h1>

        <div class="motto-list">
          <p class="motto">
            <img
              class="motto-icon"
              src="../assets/left-icon_8.png"
              [alt]="'login_page.hero_image_alt' | translate"
            />
            <span>{{ 'login_page.motto_fourth_line' | translate }}</span>
          </p>

          <p class="motto">
            <img
              class="motto-icon"
              src="../assets/left-icon_8.png"
              [alt]="'login_page.hero_image_alt' | translate"
            />
            <span>{{ 'login_page.motto_fifth_line' | translate }}</span>
          </p>

          <p class="motto">
            <img
              class="motto-icon"
              src="../assets/left-icon_8.png"
              [alt]="'login_page.hero_image_alt' | translate"
            />
            <span>{{ 'login_page.motto_sixth_line' | translate }}</span>
          </p>
        </div>
      </div>

      <div class="placeholder-container">
        <img
          class="about-illustration"
          src="../assets/craiyon_164308_image.png"
          [alt]="'login_page.hero_image_alt' | translate"
        />
      </div>
    </div>
  </section>

  <!-- Infinite horizontal scroll -->
  <section class="horizonsection" id="opportunities">
    <h1 style="text-align: center">{{ "jobs.opportunities" | translate }}</h1>
    <app-industries-card></app-industries-card>
  </section>

  <!-- Advantages -->
  <section id="section-capabilities">
    <h2 class="about-us">{{ 'communication_card.steps_label' | translate }}</h2>
    <h1>{{ 'communication_card.title' | translate }}</h1>
    <div class="advantages-grid">
      <div class="glass-card-box">
        <h3>{{ 'communication_card.smart_job_matching_title' | translate }}</h3>
        <p>{{ 'communication_card.smart_job_matching_desc' | translate }}</p>
      </div>
      <div class="glass-card-box">
        <h3>{{ 'communication_card.expert_support_title' | translate }}</h3>
        <p>{{ 'communication_card.expert_support_desc' | translate }}</p>
      </div>
      <div class="glass-card-box">
        <h3>{{ 'communication_card.trusted_title' | translate }}</h3>
        <p>{{ 'communication_card.trusted_desc' | translate }}</p>
      </div>
      <div class="glass-card-box">
        <h3>{{ 'communication_card.hire_title' | translate }}</h3>
        <p>{{ 'communication_card.hire_desc' | translate }}</p>
      </div>
      <div class="glass-card-box">
        <h3>{{ 'communication_card.seamless_title' | translate }}</h3>
        <p>{{ 'communication_card.seamless_desc' | translate }}</p>
      </div>
      <div class="glass-card-box">
        <h3>{{ 'communication_card.relocation_title' | translate }}</h3>
        <p>{{ 'communication_card.relocation_desc' | translate }}</p>
      </div>
    </div>
  </section>

  <app-landing-testimonials></app-landing-testimonials>
  <app-landing-news></app-landing-news>
  <app-landing-social></app-landing-social>

  <!-- Steps -->
  <div class="hero" id="about">
    <div class="about-us">{{ "about_us.process" | translate }}</div>
    <div class="about-us-title">{{ "about_us.process_title" | translate }}</div>
  </div>

  <div class="timeline">
    <div class="timeline-item left">
      <div class="content">
        <i class="fa fa-id-badge icon"></i>
        <h2>{{ "steps_card.step_1" | translate }}</h2>
        <p>
          {{ "steps_card.candidates_step1_title" | translate }}:{{
            "steps_card.candidates_step1_desc" | translate
          }}
        </p>
      </div>
    </div>
    <div class="timeline-item right">
      <div class="content">
        <i class="fa fa-laptop-code icon"></i>
        <h2>{{ "steps_card.step_2" | translate }}</h2>
        <p>
          {{ "steps_card.candidates_step2_title" | translate }}:{{
            "steps_card.candidates_step2_desc" | translate
          }}
        </p>
      </div>
    </div>
    <div class="timeline-item left">
      <div class="content">
        <i class="fa fa-check-circle icon"></i>
        <h2>{{ "steps_card.step_3" | translate }}</h2>
        <p>
          {{ "steps_card.candidates_step3_title" | translate }}:{{
            "steps_card.candidates_step3_desc" | translate
          }}
        </p>
      </div>
    </div>
    <div class="timeline-item right">
      <div class="content">
        <i class="fa fa-briefcase icon"></i>
        <h2>{{ "steps_card.step_4" | translate }}</h2>
        <p>
          {{ "steps_card.candidates_step4_title" | translate }}:{{
            "steps_card.candidates_step4_desc" | translate
          }}
        </p>
      </div>
    </div>
  </div>

  <!-- Arabic line + slider -->
  <div class="tounsi">و إنتي إختار</div>

  <div class="slider-container">

    <div class="before-image">
      <img
        src="../assets/unnamed-23.jpg"
        [alt]="'login_page.before_image_alt' | translate"
      />
    </div>

    <div class="after-image">
      <img
        src="../assets/unnamed-22.jpg"
        [alt]="'login_page.after_image_alt' | translate"
      />
    </div>

    <div class="slider-line"></div>

    <div class="slider-handle" id="sliderHandle">
      <div class="arrow-wrapper">
        <svg class="arrow left" width="20" height="20" viewBox="0 0 24 24">
          <path d="M16 5l-8 7 8 7"/>
        </svg>

        <svg class="arrow right" width="20" height="20" viewBox="0 0 24 24">
          <path d="M8 5l8 7-8 7"/>
        </svg>
      </div>
    </div>

  </div>

  <app-landing-team></app-landing-team>
  <app-landing-faq></app-landing-faq>

  <!-- Contact / Upload -->
  <section class="section-contact">
    <div class="contact-card">
      <!-- Upload Column -->

      <!-- Join Column -->
      <div class="join-column">
        <div class="about-us-title">{{ 'login_page.contact_title' | translate }}</div>
        <div class="section-description">{{ 'login_page.contact_description' | translate }}</div>
        <app-button
          [isFullWidth]="false"
          [label]="'login_page.join_cta' | translate"
          [size]="ButtonSize.LARGE"
          [state]="ButtonState.REGULAR"
          [type]="ButtonType.PRIMARY"
          (click)="contactUs()"
        ></app-button>
      </div>
    </div>
  </section>

  <!-- Panoramic scrolling background section -->
  <div
    class="anchor-nav xz-bike-zone"
    #bikeZone
    (mousemove)="xzOnBikeMove($event, bikeZone)"
    (mouseleave)="xzOnBikeLeave()"
  >

    <!-- Bike Guy -->
    <img
      src="./assets/craiyon_151832_image.png"
      alt=""
      [style.transform]="xzBikeTransform"
      draggable="false"
    />
  </div>

  <div class="sector">
    <img
      class="anchor-image"
      src="../assets/login-animation.png"
    />
  </div>
</div>

<app-footer></app-footer>
